import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6285745a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ml-2" }
const _hoisted_2 = { class: "field col-12 mb-4 -ml-2 -mr-2" }
const _hoisted_3 = { for: "id" }
const _hoisted_4 = {
  key: 0,
  class: "red-required pl-2"
}
const _hoisted_5 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_6 = {
  key: 0,
  class: "field col-12 mb-4 -ml-2 -mr-2"
}
const _hoisted_7 = { class: "field col-5 mb-4 -ml-2 -mr-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { for: "sure-name" }, [
  /*#__PURE__*/_createTextVNode("名前（姓）"),
  /*#__PURE__*/_createElementVNode("small", { class: "red-required pl-2" }, "必須")
], -1))
const _hoisted_9 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_10 = { class: "field col-5 mb-4 -ml-2 -mr-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { for: "first-name" }, [
  /*#__PURE__*/_createTextVNode("名前（名）"),
  /*#__PURE__*/_createElementVNode("small", { class: "red-required pl-2" }, "必須")
], -1))
const _hoisted_12 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_13 = { class: "field col-5 mb-4 -ml-2 -mr-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { for: "sure-name-kana" }, "フリガナ（姓）", -1))
const _hoisted_15 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_16 = { class: "field col-5 mb-4 -ml-2 -mr-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { for: "first-name-kana" }, "フリガナ（名）", -1))
const _hoisted_18 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_19 = { class: "field col-12 mb-4 -ml-2 -mr-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mb-2",
  for: "birthday"
}, "生年月日", -1))
const _hoisted_21 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_22 = { class: "field col-12 mb-4 -ml-2 -mr-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  for: "gender",
  class: "mb-2"
}, [
  /*#__PURE__*/_createTextVNode("性別"),
  /*#__PURE__*/_createElementVNode("small", { class: "red-required pl-2" }, "必須")
], -1))
const _hoisted_24 = { class: "formgroup-inline" }
const _hoisted_25 = ["for"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { id: "gender-help" }, null, -1))
const _hoisted_27 = { class: "field col-12 mb-4 -ml-2 -mr-2" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { for: "phone" }, "電話番号", -1))
const _hoisted_29 = { class: "field col-5 mb-4 -ml-2 -mr-2" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { for: "zipcode" }, "郵便番号", -1))
const _hoisted_31 = { class: "field col-5 mt-1 flex align-content-center flex-wrap mh-91" }
const _hoisted_32 = { class: "field col-12 mb-4 -ml-2 -mr-2" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { for: "address" }, "住所（都道府県・市区町村・丁目）", -1))
const _hoisted_34 = { class: "field col-12 mb-4 -ml-2 -mr-2" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { for: "address-number" }, "住所（番地・建物）", -1))
const _hoisted_36 = { class: "field col-12 mb-4 -ml-2 -mr-2" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { for: "email" }, "メールアドレス", -1))
const _hoisted_38 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_39 = { class: "field col-12 mb-4 -ml-2 -mr-2" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { for: "special-note" }, "特記事項", -1))
const _hoisted_41 = { class: "col-10 -ml-2 -mr-2" }
const _hoisted_42 = ["name", "value"]
const _hoisted_43 = ["name", "value"]
const _hoisted_44 = { class: "col-2 text-center break-word font-italic text-sm flex align-items-center" }
const _hoisted_45 = { class: "field col-12 mb-4 -ml-2 -mr-2" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "顧客メモ  ", -1))
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "text-right ml-5" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "formgrid formgroup-inline grid w-full flex justify-content-end flex-wrap" }

import { ref, reactive, computed, withDefaults, onUpdated } from "vue";
import * as _ from "lodash";
import { MaybeRefOrGetter, get, set, useDateFormat } from "@vueuse/core";
import Calendar from "primevue/calendar";
import RadioButton from "primevue/radiobutton";
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";
import { AccountServices, CustomerServices, ZipcodeService } from "@/clinic/services";
import {
  ApiCustomerNewReq,
  ApiCustomerShowReq,
  ApiZipcodeShowReq,
  IZipcode,
  ICustomer,
  ICustomerForm,
  ApiBaseReq,
  ISpecialNote,
} from "@/clinic/typings";
import { notifySuccessMsg, notityErrorMsg } from "@/clinic/utils/notify-utils";
import { useAsyncValidator } from "@vueuse/integrations/useAsyncValidator";
import { useRouter, useRoute } from "vue-router";
import { useRouteQuery } from "@vueuse/router";
import { Rule, Rules, ValidateError } from "async-validator";
import RouterConstants from "@/clinic/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import Unlinked from "./unlinked.vue";
import { GenderEnum } from "@/clinic/typings/enums/customer";
import { AxiosError, AxiosResponse } from "axios";
import Grid from "@/clinic/components/atoms/Grid/index.vue";
import { DATE_TIME_FORMAT } from "@/clinic/typings/constants/booking";
import { useConfirm } from "primevue/useconfirm";
import DialogNote from "./dialog-note.vue";
import { MAX_SPECIAL_NOTE } from "@/clinic/typings/constants/clinic";

type IForm = {
  clinicId: number;
  hasEdit?: boolean;
  model: ICustomer;
  rules: MaybeRefOrGetter<Record<string, Rule | Rules>>;
};

type IFormNote = {
  content: string;
};
type IFormNoteAction = {
  index?: number;
  id?: number;
  _destroy?: boolean;
  content?: string;
};
type IFieldValidator = {
  [key: string]: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'form',
  props: {
    clinicId: null,
    hasEdit: { type: Boolean, default: false },
    model: { default: {} as ICustomer },
    rules: null
  },
  setup(__props: any) {

const props = __props as { clinicId: number, hasEdit: boolean, model: ICustomer, rules: MaybeRefOrGetter<Record<string, Rule | Rules>> };



const defaultSpecialNote = { content: "" };

const form = reactive<ICustomerForm>({
  id: null,
  clinicId: null,
  lineUserId: "",
  code: "",
  sureName: "",
  firstName: "",
  name: "",
  sureNameKana: "",
  firstNameKana: "",
  nameKana: "",
  birthday: "",
  gender: "unknown",
  phone: "",
  zipcode: "",
  address: "",
  addressNumber: "",
  email: "",
  comment: "",
  lineAccountIds: [],
  commentsAttributes: [],
  specialNotesAttributes: Array.from({ length: MAX_SPECIAL_NOTE }, () => ({ ...defaultSpecialNote })),
});

const formNote = reactive<IFormNote>({
  content: "",
});
let commentsAttributesAction = ref<Array<IFormNoteAction>>([]);
const toast = useToast();
const route = useRoute();
const router = useRouter();
const visible = ref<boolean>(false);
let noteIndex = ref<number | undefined>(undefined);
let noteId = ref<number | undefined>(undefined);
const showDialogNote = ref<InstanceType<typeof DialogNote> | null>(null);
const onShowDialog = () => get(showDialogNote)?.onShow(get(formNote.content));
const confirm = useConfirm();
const columns = [
  { field: "content", header: "メモ内容", class: "col-7" },
  { field: "created_at", header: "日時", class: "col-3" },
  { field: "icon", header: "", class: "col-2" },
];

const getName = computed((): string => {
  return (get(form.sureName) + " " + get(form.firstName)).trim();
});
const getNameKana = computed((): string => {
  return (get(form.sureNameKana) + " " + get(form.firstNameKana)).trim();
});

const getAddress = async () => {
  if (!form.zipcode) return;
  const payload = { id: get(form.zipcode) } as unknown as ApiZipcodeShowReq;
  await ZipcodeService.getZipCode(
    payload,
    (response: IZipcode) => {
      const { prefecture, city } = response;
      form.address = `${prefecture} ${city}`;
    },
    () => notityErrorMsg(toast, "見つかりません")
  );
};

const initValidation = (value: IFieldValidator | any, rules: MaybeRefOrGetter<Record<string, Rule | Rules>>) =>
  useAsyncValidator(value, rules, { validateOption: { suppressWarning: true } });

const validate = async (fieldName?: string): Promise<boolean> => {
  const formRules = props.rules;
  const [value, rules] = fieldName
    ? [{ [fieldName]: form[fieldName] }, { [fieldName]: formRules[fieldName] }]
    : [form, formRules];
  const { execute } = initValidation(value, rules);
  const { pass: fPass, errorFields: fErrorFields, errors: fErrors } = await execute();
  set(pass, get(fPass));
  set(errorFields, get(fErrorFields));
  set(errors, get(fErrors));
  if (!get(pass)) {
    const fieldName = errors.value[0]?.field?.replace(/[A-Z]/g, match => `_${match.toLowerCase()}`);
    const errorElement = formRef.value?.querySelector(`[name="${fieldName}"]`);

    if (errorElement) {
      errorElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }
  return get(pass) as boolean;
};
const formRef = ref<HTMLFormElement>();
const pass = ref(false);
const errorFields = ref<Record<string, ValidateError[]>>({});
const errors = ref<ValidateError[]>([]);

const clinicIdParams = computed((): ApiBaseReq => ({ clinic_id: form.clinicId as unknown as number }));

const saveCustomer = async () => {
  updateSpecialNotes();

  const formData = new FormData(get(formRef) as unknown as HTMLFormElement);

  if (!(await validate())) return;

  await CustomerServices.saveCustomer(
    { id: form.id as unknown as number, ...get(clinicIdParams) } as ApiCustomerShowReq,
    formData as unknown as ApiCustomerNewReq,
    () => RouterUtils.goTo(RouterConstants.CUSTOMER_ROUTER_NAME),
    ({
      response: {
        data: [error],
      },
    }: AxiosError<AxiosResponse>) =>
      notityErrorMsg(toast, error ? error : "何かが間違っています。後でもう一度試してください")
  );
};

const loadModel = async () => {
  form.clinicId = (await props.clinicId) as unknown as string;
  if (!props.hasEdit || !props.model.id || props.model.id == form.id) return;
  const {
    id,
    code,
    name,
    name_kana,
    birthday,
    phone,
    zipcode,
    email,
    comment,
    gender,
    address,
    address_number: addressNumber,
    line_account_ids: lineAccountIds,
    comments_attributes: commentsAttributes,
    special_notes_attributes: specialNotesAttributes,
  } = props.model;
  const nameArray = splitJapaneseName(name);
  const sureName = nameArray?.lastName;
  const firstName = nameArray?.firstName;

  const nameKanaArray = name_kana ? splitJapaneseName(name_kana) : null;
  const sureNameKana = nameKanaArray ? nameKanaArray.lastName : "";
  const firstNameKana = nameKanaArray ? nameKanaArray.firstName : "";

  function splitJapaneseName(fullName: string) {
    // Regular expression to match Japanese characters
    const japaneseRegex = /[\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAF]+/g;

    // Extract Japanese characters from the full name
    const japaneseParts = fullName.match(japaneseRegex);
    // If there are two parts, assume the first part is the last name and the second part is the first name
    if (japaneseParts && japaneseParts.length >= 2) {
      const lastName = japaneseParts[0];
      const firstName = japaneseParts[1];
      return { lastName, firstName };
    } else {
      const nameArray = fullName.split(" ");
      return { lastName: nameArray[0], firstName: nameArray.slice(1).join(" ") };
    }
  }

  const add = MAX_SPECIAL_NOTE - (get(specialNotesAttributes)?.length || 0);
  const defaultSpecialNote = { content: "" };
  const specialNotes = [
    ...JSON.parse(JSON.stringify(get(specialNotesAttributes))),
    ...Array.from({ length: add }, () => ({ ...defaultSpecialNote })),
  ];

  const updateProps = {
    id,
    code,
    sureName,
    firstName,
    name,
    sureNameKana,
    firstNameKana,
    nameKana: name_kana,
    birthday,
    gender,
    phone,
    zipcode,
    address,
    addressNumber,
    email,
    comment,
    lineAccountIds,
    commentsAttributes,
    specialNotesAttributes: specialNotes,
  };
  Object.assign(form, updateProps);
};

const onPrevious = () => {
  const previousRouter = get(useRouteQuery("previous_name", null, { route, router }));
  const bookingId = get(useRouteQuery("booking_id", null, { route, router }));
  const query = bookingId ? { booking_id: bookingId } : {};
  RouterUtils.goToRaw({ name: previousRouter ? previousRouter : RouterConstants.CUSTOMER_ROUTER_NAME, query });
};

const onUnlinked = async (customer_id: number) => {
  await AccountServices.unlinked(
    get(clinicIdParams),
    { customer_id },
    () => notifySuccessMsg(toast, "紐付けを解除しました。"),
    () => notityErrorMsg(toast, "紐付け解除に失敗しました。")
  );
  set(form, "lineAccountIds", []);
};

const reversedCommentsArray = computed(() => {
  return form.commentsAttributes ? [...form.commentsAttributes].reverse() : [];
});

const onShowDialogEdit = async (index: number, content: string, id?: number) => {
  set(formNote, "content", content);
  onShowDialog();
  set(noteIndex, index);
  set(noteId, id);
  set(visible, true);
};

const onClosedDialog = () => {
  set(formNote, "content", "");
  set(noteIndex, undefined);
  set(noteId, undefined);
};

const onSaveNote = (contentVal: string) => {
  set(formNote, "content", contentVal);
  const content = formNote.content;
  let commentsAttributes = form.commentsAttributes || [];
  const index = noteIndex.value;
  const id = noteId.value;
  if (props.hasEdit) {
    if (index !== undefined && id) {
      commentsAttributes[index].content = content;
      commentsAttributesAction.value.push({ id, content });
    } else {
      if (index !== undefined && commentsAttributes[index]) {
        commentsAttributes[index].content = content;
        commentsAttributesAction.value = commentsAttributesAction.value.map(obj => {
          if (obj.index === index) {
            return { ...obj, content };
          }
          return obj;
        });
      } else {
        commentsAttributes = [{ content }, ...commentsAttributes];
        commentsAttributesAction.value.push({ content, index: commentsAttributes.length - 1 });
      }
    }
    set(form, "commentsAttributes", commentsAttributes);
  } else {
    if (index !== undefined && commentsAttributes[index]) {
      commentsAttributes[index].content = content;
    } else {
      commentsAttributes = [{ content }, ...commentsAttributes];
    }
    set(form, "commentsAttributes", commentsAttributes);
  }
  set(visible, false);
};

const onTrash = (index: number, id?: number) => {
  confirm.require({
    message: "顧客メモを削除します。よろしいですか？",
    header: "注意",
    rejectLabel: "キャンセル",
    acceptLabel: "OK",
    acceptClass: "p-button-danger",
    accept: async () => {
      if (props.hasEdit) {
        if (id) {
          commentsAttributesAction.value.push({ id: id, _destroy: true });
        } else {
          commentsAttributesAction.value = commentsAttributesAction.value.filter(
            obj => obj.index !== index
          ) as Array<IFormNoteAction>;
        }
      }
      form?.commentsAttributes?.splice(index, 1);
    },
  });
};

const updateSpecialNotes = () => {
  form.specialNotesAttributes?.forEach((note: ISpecialNote, index: number) => {
    if (note.content == "" && note.id != undefined) {
      const input = document.createElement("input");
      input.name = `special_notes_attributes[${index}][_destroy]`;
      input.value = "true";
      input.hidden = true;
      get(formRef).appendChild(input);
    } else {
      delete note._destroy;
    }
  });
};

onUpdated(async () => await loadModel());

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      ref_key: "formRef",
      ref: formRef,
      class: "formgrid grid mxw-600"
    }, [
      _createVNode(_component_InputText, {
        class: "hidden",
        modelValue: form.clinicId,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.clinicId) = $event)),
        name: "clinic_id",
        value: form.clinicId
      }, null, 8, ["modelValue", "value"]),
      _createVNode(_component_InputText, {
        class: "hidden",
        name: "name",
        modelValue: form.name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.name) = $event)),
        value: _unref(getName)
      }, null, 8, ["modelValue", "value"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode("カルテNo."),
          (props.hasEdit)
            ? (_openBlock(), _createElementBlock("small", _hoisted_4, "必須"))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_InputText, {
          modelValue: form.code,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.code) = $event)),
          name: "code",
          "aria-describedby": "id-help",
          type: "text",
          size: "large",
          placeholder: "プレスホルダーテキスト",
          onInput: _cache[3] || (_cache[3] = ($event: any) => (validate('code'))),
          class: _normalizeClass({ 'p-invalid': errorFields.value?.code })
        }, null, 8, ["modelValue", "class"]),
        (errorFields.value?.code)
          ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_.head(errorFields.value.code)?.message), 1))
          : _createCommentVNode("", true)
      ]),
      (props.hasEdit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(Unlinked, {
              id: props.model.id,
              onUnlinked: onUnlinked,
              disabled: form?.lineAccountIds?.length == 0
            }, null, 8, ["id", "disabled"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_InputText, {
          modelValue: form.sureName,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.sureName) = $event)),
          name: "sure_name",
          "aria-describedby": "sure-name-help",
          type: "text",
          size: "large",
          placeholder: "プレスホルダーテキスト",
          onInput: _cache[5] || (_cache[5] = ($event: any) => (validate('sureName'))),
          class: _normalizeClass({ 'p-invalid': errorFields.value?.sureName })
        }, null, 8, ["modelValue", "class"]),
        (errorFields.value?.sureName)
          ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(_.head(errorFields.value.sureName)?.message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode(_component_InputText, {
          modelValue: form.firstName,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.firstName) = $event)),
          name: "first_name",
          "aria-describedby": "first-name-help",
          type: "text",
          size: "large",
          placeholder: "プレスホルダーテキスト",
          onInput: _cache[7] || (_cache[7] = ($event: any) => (validate('firstName'))),
          class: _normalizeClass({ 'p-invalid': errorFields.value?.firstName })
        }, null, 8, ["modelValue", "class"]),
        (errorFields.value?.firstName)
          ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_.head(errorFields.value.firstName)?.message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_InputText, {
          class: "hidden",
          name: "name_kana",
          modelValue: form.nameKana,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.nameKana) = $event)),
          value: _unref(getNameKana)
        }, null, 8, ["modelValue", "value"]),
        _hoisted_14,
        _createVNode(_component_InputText, {
          modelValue: form.sureNameKana,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.sureNameKana) = $event)),
          name: "sure_name_kana",
          "aria-describedby": "sure-name-kana-help",
          type: "text",
          size: "large",
          placeholder: "プレスホルダーテキスト",
          onInput: _cache[10] || (_cache[10] = ($event: any) => (validate('sureNameKana'))),
          class: _normalizeClass({ 'p-invalid': errorFields.value?.sureNameKana })
        }, null, 8, ["modelValue", "class"]),
        (errorFields.value?.sureNameKana)
          ? (_openBlock(), _createElementBlock("small", _hoisted_15, _toDisplayString(_.head(errorFields.value.sureNameKana)?.message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createVNode(_component_InputText, {
          modelValue: form.firstNameKana,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.firstNameKana) = $event)),
          name: "first_name_kana",
          "aria-describedby": "first-name-kana-help",
          type: "text",
          size: "large",
          placeholder: "プレスホルダーテキスト",
          onInput: _cache[12] || (_cache[12] = ($event: any) => (validate('firstNameKana'))),
          class: _normalizeClass({ 'p-invalid': errorFields.value?.firstNameKana })
        }, null, 8, ["modelValue", "class"]),
        (errorFields.value?.firstNameKana)
          ? (_openBlock(), _createElementBlock("small", _hoisted_18, _toDisplayString(_.head(errorFields.value.firstNameKana)?.message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createVNode(_component_InputText, {
          name: "birthday",
          modelValue: form.birthday,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.birthday) = $event)),
          class: "hidden"
        }, null, 8, ["modelValue"]),
        _createVNode(_unref(Calendar), {
          id: "birthday",
          modelValue: form.birthday,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.birthday) = $event)),
          "aria-describedby": "birthday-help",
          type: "date",
          size: "large",
          placeholder: "yyyy/mm/dd",
          dateFormat: "yy/mm/dd",
          onDateSelect: _cache[15] || (_cache[15] = ($event: any) => (validate('birthday'))),
          class: _normalizeClass({ 'p-invalid': errorFields.value?.birthday })
        }, null, 8, ["modelValue", "class"]),
        (errorFields.value?.birthday)
          ? (_openBlock(), _createElementBlock("small", _hoisted_21, _toDisplayString(_.head(errorFields.value.birthday)?.message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_unref(GenderEnum)), ([name, nameJp]) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "field-radiobutton",
              key: name
            }, [
              _createVNode(_unref(RadioButton), {
                modelValue: form.gender,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.gender) = $event)),
                inputId: `gender_${name}`,
                name: "gender",
                value: name
              }, null, 8, ["modelValue", "inputId", "value"]),
              _createElementVNode("label", {
                for: `gender_${name}`,
                class: "ml-2"
              }, _toDisplayString(nameJp), 9, _hoisted_25)
            ]))
          }), 128))
        ]),
        _hoisted_26
      ]),
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        _createVNode(_component_InputText, {
          modelValue: form.phone,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.phone) = $event)),
          "aria-describedby": "phone-help",
          type: "text",
          size: "large",
          name: "phone",
          placeholder: "プレスホルダーテキスト"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _createVNode(_component_InputText, {
          modelValue: form.zipcode,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.zipcode) = $event)),
          "aria-describedby": "zipcode-help",
          type: "text",
          size: "large",
          name: "zipcode",
          placeholder: "プレスホルダーテキスト"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createVNode(_component_Button, {
          class: "btn-primary h-3rem w-9 align-items-center border-transparent",
          onClick: getAddress,
          label: "郵便番号で検索"
        })
      ]),
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _createVNode(_component_InputText, {
          modelValue: form.address,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((form.address) = $event)),
          "aria-describedby": "address-help",
          type: "text",
          size: "large",
          name: "address",
          class: "max-w-full",
          placeholder: "プレスホルダーテキスト"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _hoisted_35,
        _createVNode(_component_InputText, {
          modelValue: form.addressNumber,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((form.addressNumber) = $event)),
          "aria-describedby": "address-number-help",
          type: "text",
          size: "large",
          name: "address_number",
          class: "max-w-full",
          placeholder: "プレスホルダーテキスト"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _hoisted_37,
        _createVNode(_component_InputText, {
          modelValue: form.email,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((form.email) = $event)),
          "aria-describedby": "email-help",
          type: "text",
          size: "large",
          name: "email",
          class: _normalizeClass(["mxw-444", { 'p-invalid': errorFields.value?.email }]),
          placeholder: "プレスホルダーテキスト",
          onInput: _cache[22] || (_cache[22] = ($event: any) => (validate('email')))
        }, null, 8, ["modelValue", "class"]),
        (errorFields.value?.email)
          ? (_openBlock(), _createElementBlock("small", _hoisted_38, _toDisplayString(_.head(errorFields.value.email)?.message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_39, [
        _hoisted_40,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.specialNotesAttributes, (note, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "flex",
            key: index
          }, [
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_component_Textarea, {
                class: _normalizeClass([{ 'p-invalid': errorFields.value?.specialNote }, "max-w-full w-full mt-1"]),
                modelValue: note.content,
                "onUpdate:modelValue": ($event: any) => ((note.content) = $event),
                size: "large",
                style: {"min-height":"10vh","max-height":"40vh"},
                placeholder: "プレスホルダーテキスト"
              }, null, 8, ["class", "modelValue", "onUpdate:modelValue"]),
              (note.id)
                ? (_openBlock(), _createElementBlock("input", {
                    key: 0,
                    hidden: "",
                    name: `special_notes_attributes[${index}][id]`,
                    value: note.id
                  }, null, 8, _hoisted_42))
                : _createCommentVNode("", true),
              (note.id || note.content != '')
                ? (_openBlock(), _createElementBlock("input", {
                    key: 1,
                    hidden: "",
                    name: `special_notes_attributes[${index}][content]`,
                    value: note.content
                  }, null, 8, _hoisted_43))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(get)(_unref(useDateFormat)(note.updated_at, _unref(DATE_TIME_FORMAT)))), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_45, [
        _hoisted_46,
        _createElementVNode("i", {
          class: "pi pi-pencil icon-pi-pencil-orange cursor-pointer",
          onClick: onShowDialog
        }),
        (props.hasEdit)
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(commentsAttributesAction), (comment, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  (comment.content)
                    ? (_openBlock(), _createBlock(_component_InputText, {
                        key: 0,
                        name: `comments_attributes[${index}][content]`,
                        class: "hidden",
                        value: comment.content
                      }, null, 8, ["name", "value"]))
                    : _createCommentVNode("", true),
                  (comment.id)
                    ? (_openBlock(), _createBlock(_component_InputText, {
                        key: 1,
                        name: `comments_attributes[${index}][id]`,
                        class: "hidden",
                        value: comment.id
                      }, null, 8, ["name", "value"]))
                    : _createCommentVNode("", true),
                  (comment._destroy)
                    ? (_openBlock(), _createBlock(_component_InputText, {
                        key: 2,
                        name: `comments_attributes[${index}][_destroy]`,
                        class: "hidden",
                        value: comment._destroy
                      }, null, 8, ["name", "value"]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_48, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reversedCommentsArray), (comment, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createVNode(_component_InputText, {
                    name: `comments_attributes[${index}][content]`,
                    class: "hidden",
                    value: comment.content
                  }, null, 8, ["name", "value"])
                ]))
              }), 128))
            ])),
        _createVNode(Grid, {
          items: form.commentsAttributes,
          index: _ctx.index,
          columns: columns,
          "max-note": form.commentsAttributes.length
        }, {
          content: _withCtx(({ data }) => [
            _createElementVNode("div", {
              innerHTML: data.content.replace(/\n/g, '<br>')
            }, null, 8, _hoisted_49)
          ]),
          created_at: _withCtx(({ data }) => [
            (data.created_at)
              ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_unref(get)(_unref(useDateFormat)(data.created_at, _unref(DATE_TIME_FORMAT)))), 1))
              : _createCommentVNode("", true)
          ]),
          icon: _withCtx(({ data, index }) => [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("i", {
                class: "pi pi-pencil cursor-pointer mr-2",
                onClick: ($event: any) => (onShowDialogEdit(index, data.content, data.id))
              }, null, 8, _hoisted_52),
              _createElementVNode("i", {
                class: "pi pi-trash cursor-pointer",
                onClick: ($event: any) => (onTrash(index, data.id))
              }, null, 8, _hoisted_53)
            ])
          ]),
          _: 1
        }, 8, ["items", "index", "max-note"])
      ]),
      _createElementVNode("div", _hoisted_54, [
        _createVNode(_component_Button, {
          class: "btn-white min-w-212 h-3rem",
          label: "キャンセル",
          onClick: onPrevious
        }),
        _createVNode(_component_Button, {
          class: "btn-primary flex justify-content-end ml-3 min-w-212 h-3rem",
          label: props.hasEdit ? '保存する' : '新規作成',
          onClick: saveCustomer
        }, null, 8, ["label"])
      ])
    ], 512),
    _createVNode(DialogNote, {
      ref_key: "showDialogNote",
      ref: showDialogNote,
      onClose: onClosedDialog,
      onSave: onSaveNote
    }, null, 512),
    _createVNode(_unref(Toast), { position: "top-center" })
  ]))
}
}

})